import React from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm, IAdditionalPassport } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { Box } from '@chakra-ui/react';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';
import { useTranslation } from "react-i18next";

function VisaPrepAdditionalPersonalInfo(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  const renderAdditionalPassports = () => {
    const allAdditionalPassports: React.ReactNode[] = [];
    if (props.additionalPassports && props.additionalPassports.length) {
      props.additionalPassports.forEach((passport: IAdditionalPassport, i: number) => {
        allAdditionalPassports.push(
          <SummaryGroup title={t('forms.visa:additionalPassport', { i: i + 1 })} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.ADDITIONAL_PASSPORT_PASSPORT_NUMBER}-${i}`}
              label={t('forms.visa:currentPassportOrTravelDocumentN2')}
              value={passport.docNumber}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.ADDITIONAL_PASSPORT_PLACE_OF_ISSUE}-${i}`}
              label={t('forms.visa:placeOfIssue')}
              value={passport.placeOfIssue}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.ADDITIONAL_PASSPORT_ISSUING_AUTHORITY}-${i}`}
              value={passport.issuingAuthority}
              label={t('forms.visa:issuingAuthority')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.ADDITIONAL_PASSPORT_DATE_OF_ISSUE}-${i}`}
              label={t('forms.visa:dateOfIssue')}
              value={passport.issueDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.ADDITIONAL_PASSPORT_DATE_OF_EXPIRY}-${i}`}
              label={t('forms.visa:dateOfExpiry')}
              value={passport.expiryDate}
            />
          </SummaryGroup>,
        );
      });
    }
    return allAdditionalPassports;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_ADDITIONAL_PASSPORTS}
        label={t('forms.visa:hasAdditionalPassports')}
        fullLabel={`Have you had any other passports in the last 10 years?`}
        value={boolToYesNo(props.hasAdditionalPassports)}
      />
      {props.hasAdditionalPassports ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            label={t('forms.visa:howManyAdditionalPassports')}
            value={props.additionalPassports?.length}
          />

          <Box as="ol" pl={8} key={'additional-passports'}>
            {renderAdditionalPassports()}
          </Box>
        </>
      ) : null}
    </>
  );
}

export default VisaPrepAdditionalPersonalInfo;
